// extracted by mini-css-extract-plugin
export var button = "technology-blog-module--button--4RVPu";
export var section = "technology-blog-module--section--GoPzO";